'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.mapFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/mapFromIndex.js
// module id = 410
// module chunks = 0